import KeyValueListDisplay from '@/components/KeyValueDisplay';
import { displayFullName } from '@/lib/utils';
import type { HomeInspectionWorkOrderResponse } from '@/types/homeInspection.types';

const REPRESENTS_LABEL: Record<string, string> = {
  PLAINTIFF: 'Plaintiff',
  DEFENDANT: 'Defendant',
};

const RUSH_LABEL: Record<string, string> = {
  SAME_DAY: 'Yes (Same Day)',
  NEXT_DAY: 'Yes (Next Day)',
  NONE: 'No',
};

type Props = { workOrder: HomeInspectionWorkOrderResponse };

export const HIWorkOrderSidePanelClientInfo = ({ workOrder }: Props) => {
  const assignedUserName = workOrder.user ? displayFullName(workOrder.user) : '-';
  const teamName = workOrder.team?.name ?? '-';

  const contactName = workOrder.contact ? displayFullName(workOrder.contact) : workOrder.contactName || '-';
  const contactEmail = workOrder.contact?.email ?? workOrder.contactEmail ?? '-';
  const lawyerName = workOrder.lawyerContact ? displayFullName(workOrder.lawyerContact) : '-';
  const clientIdentifier = workOrder.clientCode ?? workOrder.clientId ?? '-';

  const details = [
    { label: 'Client ID', value: clientIdentifier },
    { label: 'Client Contact', value: contactName },
    { label: 'Contact Email', value: contactEmail },
    { label: 'File Number', value: workOrder.fileNumber ?? '-' },
    { label: 'Lawyer', value: lawyerName },
    {
      label: 'Represents',
      value: workOrder.represents ? (REPRESENTS_LABEL[workOrder.represents] ?? workOrder.represents) : '-',
    },
    { label: 'Case Name', value: workOrder.caseName ?? '-' },
    { label: 'Case Number', value: workOrder.caseNumber ?? '-' },
    { label: 'Rush', value: RUSH_LABEL[workOrder.rushType] ?? '-' },
    { label: 'Team', value: teamName },
    { label: 'Assigned User', value: assignedUserName },
  ];

  return (
    <div className="flex flex-col gap-4 w-full px-6 py-4">
      <div className="flex flex-col gap-2 w-full text-sm">
        <KeyValueListDisplay data={details} />
      </div>
    </div>
  );
};
